<template>
    <div class="animated fadeIn">
        <spinner v-if="loading"/>
      <b-card>
          <div slot="header">
            <strong>Search SRR</strong>
          </div>
          <b-row>
              <b-col sm="2">
                  <b-form-group>
                      <label for="wto_num">SRF No</label>
                          <b-form-input type="text" id="wto_num" v-model="filter.srf_num"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                  <b-form-group>
                      <label for="gro_num">SRR No</label>
                          <b-form-input type="text" id="wtr_num" v-model="filter.srr_num"></b-form-input>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                  <b-form-group>
                      <label for="country_id">Country</label>
                        <countryLookup v-bind:url="apiCountryLookup" v-on:selected="setCountry($event)" :lookupId="filter.country_id"/>
                  </b-form-group>
              </b-col>
              <b-col sm="2">
                <b-form-group>
                    <label for="date_start">Date Start</label>
                        <b-form-input type="date" v-model="filter.date_start"></b-form-input>
                </b-form-group>
              </b-col>
            <b-col sm="2">
                <b-form-group>
                    <label for="date_end">Date End</label>
                        <b-form-input type="date" v-model="filter.date_end"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="2">
              <b-form-group>
                  <label>Returning Type</label>
                    <b-form-select id="returning_type" v-model="filter.returning_type"
                    :plain="true"
                    :options="['','RETURNABLE','NON RETURNABLE']"
                    >
              </b-form-select>
              </b-form-group>
          </b-col>
          </b-row>
          <div slot="footer">
              <b-button type="submit" size="lg" variant="primary" @click="search">Search</b-button>
              &nbsp;&nbsp;
              <b-button type="submit" size="lg" variant="success" @click="newSRR">New SRR</b-button>
          </div>
      </b-card>
      <b-row v-if="getRowCount(searchResults) > 0 && !loading">
          <b-col sm="12" >
            <b-card>
                <div slot="header">
                    <strong>Search Results</strong>
                </div>
                <b-table class="table-hover" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :fields="searchResultsFields" :current-page="currentPage" 
                :per-page="perPage" :items="searchResults" @row-clicked="rowClick">
                </b-table>
              <nav>
                <b-pagination :total-rows="getRowCount(searchResults)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
              </nav>
              <div slot="footer">
                  <exportExcel class   = "btn btn-primary btn-lg" size ="lg" :data   = "searchResults" :fields = "exportHeaders" name = "srr.xls">
                      Export to Excel
                  </exportExcel>
                  &nbsp;
                  <b-button type="submit" size="lg" variant="success" @click="print">Print</b-button>
              </div>
            </b-card>
          </b-col>
      </b-row>
      <b-row v-else-if="noResults && !loading" >
              <b-col sm="12">
                <div align="center">
                  <strong>No SRR Found</strong>
                </div>                    
              </b-col>
      </b-row>
    </div>
  </template>
  <script>
  import axios from 'axios'
  import spinner from '@/components/Spinner.vue'
  import countryLookup from '@/components/Autocomplete.vue'
  import {authHeader, apiCountryLookup} from '@/functions/common.vue'
  import {apiSrfSearch} from '@/functions/common.vue'
  import exportExcel from 'vue-json-excel'
  import pdfMake from "pdfmake/build/pdfmake";
  import pdfFonts from "pdfmake/build/vfs_fonts";
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  pdfMake.fonts = {
      "ukai": {
         normal: 'ukai.ttf',
          bold: 'ukai.ttf',
          italics: 'ukai.ttf',
           bolditalics: 'ukai.ttf'
      },
   };
  
  export default 
    {
      components:{spinner,countryLookup,exportExcel},
      props: {
        caption: 
        {
          type: String,
          default: 'Table'
        },
        hover: 
        {
          type: Boolean,
          default: false
        },
        striped: 
        {
          type: Boolean,
          default: false
        },
        bordered: 
        {
          type: Boolean,
          default: false
        },
        small: 
        {
          type: Boolean,
          default: false
        },
        fixed: 
        {
          type: Boolean,
          default: false
        }
      },
      data: () => {
        return {
          apiCountryLookup:apiCountryLookup,
          loading: false,
          noResults: false,
          filter: 
            {
              srf_num: '',
              srr_num:'',
              country_id: '',
              date_start: '',
              date_end: '',
              returning_type:'RETURNABLE',
            },  
          searchResults: [],
          searchResultsFields: 
          [
          {key: 'country_id', label: 'Country'},
          {key: 'location_id' ,label: 'Location'},
          {key: 'srf_date' ,label: 'SRF Date'},
          {key: 'srf_num' ,label: 'Last SRR'},
          {key: 'status' ,label: 'Status'},
          {key: 'last_srr_date' ,label: 'SRR Date'},
          {key: 'last_srr_num' ,label: 'SRR No'},
          {key: 'requestor_user_shortname' ,label: 'Requestor Name'}
          ],
          currentPage: 1,
          perPage: 20,
          totalRows: 0,
          noResults: false,
          exportHeaders:
          {
            'SRF No': 'srf_num',
            'Date': 'srf_date',
            'Country': 'country_id',
            'Location': 'location_id',
            'Last SRR No':'last_srr_num',
            'Last SRR Date':'last_srr_date',
            'Status':'status',
            'Requestor Name':'requestor_user_shortname',
          },
        }
      },
      methods: 
      {
        print()
          {
                var rows = []
                var row = []
                var date = new Date()
                rows.push([
                'SRF No',
                'Date',
                'Country',
                'Location',
                'Last SRR No',
                'Last SRR Date',
                'Status',
                'Requestor Name'
                ])

                for (let key in this.searchResults)
                {
                  var data = this.searchResults[key]
                  row = [
                    data.srf_num, 
                    data.srf_date,
                    data.country_id,
                    data.location_id,
                    data.last_srr_num,
                    data.last_srr_date,
                    data.status,
                    data.requestor_user_shortname
                ]
                  rows.push(row)
                }
                var dd = {
                  header:{ text: 'Stock Requisition Return List generated on'+ " "+ date, margin: [ 5, 10, 10, 30 ],alignment: 'center',fontSize:9 },
                  pageSize: 'A4',
                  pageOrientation: 'portrait',
                  defaultStyle: {
                    font: 'ukai'
                  },
                  // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                  pageMargins: [30, 30, 30, 20 ],

                  content: [
                    {
                      fontSize: 9.5,
                      layout: 'lightHorizontalLines', // optional
                      table: 
                      {
                        // headers are automatically repeated if the table spans over multiple pages
                        // you can declare how many rows should be treated as headers
                        headerRows: 1,
                        widths: [ 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: 
                          rows
                      }
                    }
                  ]
                };
                pdfMake.createPdf(dd).open();
          },
        getRowCount (items) 
        {
          return items.length
        },
        search()
        {
          this.loading = true
          this.noResults =true
          var sf =
          [
            "srf_num LIKE " + this.filter.srf_num
            ,"srrs_list LIKE " + this.filter.srr_num
            ,"country_id = " + this.filter.country_id
            ,"srr_date >= " + this.filter.date_start
            ,"srr_date <= " + this.filter.date_end
            ,"returning_type = " + this.filter.returning_type
          ]
          axios.post(apiSrfSearch, sf)
            .then (res => 
            {
                return res
            })
            .then (data =>
            {
                const resultArray = []
                const myData = data.data.data.list
               
                for (let key in myData)
                {
                    var date = myData[key].last_srr_date
                    var srfDate = myData[key].srf_date
                    srfDate = new Date(srfDate);
                    var srfDateResult ="" + (srfDate.getDate() > 9 ? '' : '0') + srfDate.getDate() + '/'+  ((srfDate.getMonth() + 1) > 9 ? '' : '0') + (srfDate.getMonth() + 1) + '/' + srfDate.getFullYear()
                    if (date !== null)
                    {
                      date = new Date(date);
                      var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                    }
                    else
                    {
                      result = "-" 
                    }    
                    var last_srr = '-'      
                    //console.log(myData[key].last_srr_num)      
                    if(myData[key].last_srr_num != null)   
                    {
                      last_srr = myData[key].last_srr_num
                    } 
                    myData[key].last_srr_num = last_srr
                    myData[key].last_srr_date=result
                    myData[key].srf_date = srfDateResult
                    resultArray.push(myData[key])
                    this.loading = false
                }
                this.searchResults = resultArray
                
                if(this.searchResults.length ==0)
                {
                    this.loading = false
                    this.noResults =true
                }
            })
            .catch(error => alert(error)) 
        },
        newSRR()
        {
          localStorage.setItem("srr_new.srf_num","")
          this.$router.push({ name: 'Stock Requisition Return Entry (SRR)', params: { srrNum: '_new' }})
        },
        setCountry(obj)
        {
              var id
              if (obj !== null)
              {
                id = obj.id
              } 
              else
              {
                id = null
              }
              this.filter.country_id = id
        },
        rowClick(item)
        {
          localStorage.setItem("srr_new.srf_num", item.srf_num)
          this.$router.push({ name: 'Stock Requisition Return Entry (SRR)', params: { srrNum: '_new' }}) 
        }
      }
    }
  </script>
  


// WEBPACK FOOTER //
// src/views/srr/srrs.vue